// =============================================================================
// Entry-token hand-over (security audit V3-09).
//
// The JWE entry token arrives as ?orderKey=… . The guard script at the top of index.html moves it
// into sessionStorage and out of the address bar before GTM or Sentry can read the URL. The app
// reads it here. If the guard could not store it (storage blocked), the token is still in the
// URL: it is taken from there and stripped, so it never stays visible.
// =============================================================================

export const ENTRY_TOKEN_KEY = 'v3_entry_token'
const PARAM = 'orderKey'

/** The entry token of this visit, or null. It stays stored until clearEntryToken(). */
export function readEntryToken() {
  try {
    const stored = window.sessionStorage.getItem(ENTRY_TOKEN_KEY)
    if (stored) return stored
  } catch {
    /* storage blocked — fall through to the URL */
  }

  const url = new URL(window.location.href)
  const token = url.searchParams.get(PARAM)
  if (!token) return null

  url.searchParams.delete(PARAM)
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
  return token
}

/** Forget the token once the server has answered: it is spent or refused either way. */
export function clearEntryToken() {
  try {
    window.sessionStorage.removeItem(ENTRY_TOKEN_KEY)
  } catch {
    /* ignore storage failures */
  }
}
